module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.closeClick),
      expression: "closeClick"
    }],
    ref: "d_show_event",
    staticClass: "d-show-event",
    class: {
      'd-show-event__changes-made': _vm.isChangesMade
    },
    attrs: {
      "data-event-id": _vm.event ? _vm.event.event_id : ''
    }
  }, [(!_vm.isEveryThingReady) ? _c('div', {
    staticClass: "d-show-event__init-loader"
  }, [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        placement: 'bottom',
        zIndex: 1212121212
      }),
      expression: "{\n               placement: 'bottom',\n               zIndex: 1212121212\n             }"
    }],
    staticClass: "d-show-event__close d-show-event__close__loader icon__bg-circle",
    attrs: {
      "content": _vm.escTooltip
    },
    on: {
      "click": _vm.closeClick
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })]), _vm._v(" "), _c('Loader', {
    attrs: {
      "bg-color": "#f6f9fc"
    }
  })], 1) : _c('div', {
    staticClass: "d-show-event__content"
  }, [_c('div', {
    ref: "d_show_event_header",
    staticClass: "d-show-event__header",
    style: ({
      backgroundColor: _vm.event.color
    })
  }, [_c('div', {
    staticClass: "d-show-event__header__do-warning__container"
  }, [(_vm.isCanceled) ? _c('div', {
    staticClass: "d-show-event__header__do-warning do-warning do-warning--canceled"
  }, [_c('span', {
    staticClass: "icon-notification22"
  }), _vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale].canceled) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isAway) ? _c('div', {
    staticClass: "d-show-event__header__do-warning do-warning"
  }, [_c('span', {
    staticClass: "icon-home2 icon-home2-away",
    staticStyle: {
      "margin-right": "2px"
    }
  }), _vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale].out_of_school))]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "copy_event_button",
    staticClass: "d-show-event__header__top",
    attrs: {
      "id": "vue-popper__copy_event_button"
    }
  }, [(_vm.isCanEditEvent) ? [(_vm.event.calendar_id !== _vm.calendarId) ? _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        placement: 'bottom',
        zIndex: 1212121212
      }),
      expression: "{\n        placement: 'bottom',\n        zIndex: 1212121212\n      }"
    }],
    staticClass: "icon__bg-circle",
    attrs: {
      "content": _vm.i18n[_vm.locale]['go_to_calendar']
    },
    on: {
      "click": _vm.goToCalendarForLesson
    }
  }, [_c('svg', {
    staticClass: "tw-icon w-6 h-6",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.event.calendar_id !== _vm.calendarId && _vm.eventMainCalendarType === 'merge') ? _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        placement: 'bottom',
        zIndex: 1212121212
      }),
      expression: "{\n        placement: 'bottom',\n        zIndex: 1212121212\n      }"
    }],
    staticClass: "icon__bg-circle dialog-header__bin",
    attrs: {
      "content": _vm.i18n[_vm.locale]['only_delete_this']
    },
    on: {
      "click": _vm.setIsConfirmDeleteMerge
    }
  }, [_c('span', {
    staticClass: "icon-bin pointer"
  })]) : _vm._e(), _vm._v(" "), (_vm.isPossibleToDelete) ? _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        placement: 'bottom',
        zIndex: 1212121212
      }),
      expression: "{\n        placement: 'bottom',\n        zIndex: 1212121212\n      }"
    }],
    staticClass: "icon__bg-circle dialog-header__bin",
    attrs: {
      "content": _vm.i18n[_vm.locale]['delete_event']
    },
    on: {
      "click": function($event) {
        _vm.isConfirmDelete = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-bin pointer"
  })]) : _vm._e(), _vm._v(" "), (_vm.event.calendar_id === _vm.calendarId && _vm.showSettings && _vm.event.event_type !== 'absence') ? _c('DDropdown', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        placement: 'bottom',
        zIndex: 12121212
      }),
      expression: "{placement: 'bottom', zIndex: 12121212}"
    }],
    attrs: {
      "content": _vm.i18n[_vm.locale]['settings']
    }
  }, [_c('ul', {
    staticClass: "large-list",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('li', {
    on: {
      "click": _vm.openCopyEventDropdown
    }
  }, [_c('span', {
    staticClass: "icon-clipboard2"
  }), _vm._v("\n                " + _vm._s(_vm.i18n[_vm.locale]['copy_event_onward']) + "\n              ")]), _vm._v(" "), _c('li', {
    staticClass: "d-item-warning",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.setIsDeleteOnWard.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "icon-bin"
  }), _vm._v("\n                " + _vm._s(_vm.i18n[_vm.locale].delete_events_onward) + "\n              ")]), _vm._v(" "), _c('li', {
    staticClass: "d-cancel-lesson-item",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setIsCancelLesson(true)
      }
    }
  }, [_c('span', {
    staticClass: "icon-notification22"
  }), _vm._v("\n                " + _vm._s(!_vm.isCanceled ? _vm.i18n[_vm.locale].cancel_event : _vm.i18n[_vm.locale].uncancel_event) + "\n              ")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setIsOutOfSchoolLesson(true)
      }
    }
  }, [_c('span', {
    staticClass: "icon-home2 icon-home2-away"
  }), _vm._v("\n                " + _vm._s(_vm.i18n[_vm.locale].out_of_school) + "\n              ")])])]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        placement: 'bottom',
        zIndex: 1212121212
      }),
      expression: "{\n               placement: 'bottom',\n               zIndex: 1212121212\n             }"
    }],
    staticClass: "d-show-event__close icon__bg-circle",
    attrs: {
      "content": _vm.escTooltip
    },
    on: {
      "click": _vm.closeClick
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])], 2), _vm._v(" "), (_vm.isDeleteOnWard) ? _c('DeleteEventOnward', {
    attrs: {
      "isInDCalendar": true,
      "event": _vm.event
    },
    on: {
      "submit": _vm.submitDeleteEventOnward,
      "close": function($event) {
        _vm.isDeleteOnWard = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isInDCalendar) ? _c('CopyEvent') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-show-event__header__text"
  }, [_c('h1', [_vm._v(_vm._s(_vm.event.title))]), _vm._v(" "), (_vm.isCanEditEvent && _vm.event.calendar_id !== _vm.calendarId) ? _c('h4', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        placement: 'bottom-start',
        zIndex: 1212121212
      }),
      expression: "{\n              placement: 'bottom-start',\n              zIndex: 1212121212\n            }"
    }],
    class: {
      'd-show-event__header__text__calendar-link': _vm.event.calendar_id !== _vm.calendarId
    },
    attrs: {
      "content": _vm.i18n[_vm.locale]['go_to_calendar']
    },
    on: {
      "click": _vm.goToCalendarForLesson
    }
  }, [_vm._v("\n          " + _vm._s(_vm.getCalendarName) + "\n          "), _c('svg', {
    staticClass: "tw-icon w-6 h-6",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
    }
  })])]) : _c('h4', [_vm._v(_vm._s(_vm.getCalendarName))])]), _vm._v(" "), (!_vm.isEventLoading) ? [_c('div', {
    staticClass: "d-show-event__header__text--with-icon"
  }, [_c('div', {
    staticClass: "dialog-icon"
  }, [(_vm.isCanEditEvent) ? _c('span', {
    staticClass: "icon-calendar4"
  }) : _vm._e()]), _vm._v(" "), (!_vm.isCanEditEvent) ? _c('div', {
    staticClass: "dialog-text dialog-text__time"
  }, [_vm._v("\n            " + _vm._s(_vm.dayAndDate) + "\n          ")]) : _c('div', {
    staticClass: "dialog-text dialog-text__date"
  }, [(!_vm.isEditDate) ? _c('p', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        placement: 'bottom',
        zIndex: 1212121212
      }),
      expression: "{\n               placement: 'bottom',\n               zIndex: 1212121212\n             }"
    }],
    attrs: {
      "content": _vm.i18n[_vm.locale]['edit_date']
    },
    on: {
      "click": function($event) {
        _vm.isEditDate = true
      }
    }
  }, [_vm._v(_vm._s(_vm.dayAndDate))]) : _c('DateSelector', {
    attrs: {
      "isOpen": true,
      "date": _vm.startDate
    },
    on: {
      "changed": _vm.setStartDate
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-show-event__header__text--with-icon"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "dialog-text dialog-text__time"
  }, [(!_vm.isCanEditEvent) ? _c('div', {
    staticClass: "dialog-text__time__time"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.formattedEventStart) + " - " + _vm._s(_vm.formattedEventEnd))]), _vm._v("\n              (" + _vm._s(_vm.formattedDuration) + ")\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isCanEditEvent) ? _c('TimeChanger', {
    attrs: {
      "start": _vm.event.start,
      "end": _vm.event.end,
      "addClass": "doc-times"
    },
    on: {
      "updateStart": _vm.updateStartTime,
      "updateEnd": _vm.updateEndTime
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "zoomIn"
    }
  }, [(_vm.isChangesMade) ? _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        placement: 'bottom',
        zIndex: 12312312312312
      }),
      expression: "{\n                  placement : 'bottom',\n                  zIndex: 12312312312312\n                }"
    }],
    staticClass: "bttn-primary bttn box-shadow",
    attrs: {
      "content": _vm.saveKeyTooltip
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('vue2.common.save')) + "\n              ")]) : _vm._e()])], 1)])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-show-event__header__tabs"
  }, [_c('div', {
    staticClass: "d-show-event__header__tabs__tab",
    class: {
      'd-show-event__header__tabs__tab--active': _vm.isTheActiveTab(0)
    },
    on: {
      "click": function($event) {
        return _vm.setTheActiveTab(0)
      }
    }
  }, [_c('span', {
    staticClass: "icon-pencil"
  }), _vm._v(" " + _vm._s(_vm.$t('vue2.common.edit')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "d-show-event__header__tabs__tab",
    class: {
      'd-show-event__header__tabs__tab--active': _vm.isTheActiveTab(1)
    },
    on: {
      "click": function($event) {
        return _vm.setTheActiveTab(1)
      }
    }
  }, [_c('span', {
    staticClass: "icon-clock"
  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['activity']) + "\n        ")]), _vm._v(" "), (_vm.isShowReplaceAndSwap) ? _c('div', {
    staticClass: "d-show-event__header__tabs__tab",
    class: {
      'd-show-event__header__tabs__tab--active': _vm.isTheActiveTab(2)
    },
    on: {
      "click": function($event) {
        return _vm.setTheActiveTab(2)
      }
    }
  }, [_c('span', {
    staticClass: "icon-shuffle"
  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['swap_lesson']) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isShowReplaceAndSwap) ? _c('div', {
    staticClass: "d-show-event__header__tabs__tab",
    class: {
      'd-show-event__header__tabs__tab--active': _vm.isTheActiveTab(3)
    },
    on: {
      "click": function($event) {
        return _vm.setTheActiveTab(3)
      }
    }
  }, [_c('span', {
    staticClass: "icon-shuffle"
  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['replace_lesson']) + "\n        ")]) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "d-show-event__body",
    style: ({
      maxHeight: ("calc(100vh - " + _vm.dShowEventBodyMaxHeight + "px)")
    })
  }, [(_vm.isEventLoading) ? _c('Loader', {
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "bg-color": "#f6f9fc"
    }
  }) : [(_vm.isTheActiveTab(0)) ? _c('div', {
    staticClass: "d-show-event__form"
  }, [(!_vm.isCanEditEvent) ? [(_vm.eventUsers.length > 0 && _vm.event.event_type !== 'absence') ? _c('div', {
    staticClass: "input-group input-group--uneditable"
  }, [_c('label', [_c('span', {
    staticClass: "icon-user"
  }), _vm._v(" " + _vm._s(_vm.$t('vue2.edit_event.teachers')))]), _vm._v(" "), _c('div', {
    staticClass: "event-cals"
  }, _vm._l((_vm.eventUsers), function(user) {
    return _c('div', {
      key: user.calendar_id,
      staticClass: "event-cals__cal",
      class: {
        'event-cals__cal--sub': user.v_sub
      }
    }, [(user.v_sub) ? _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          placement: 'bottom',
          zIndex: 1231231231233,
          boundary: 'window'
        }),
        expression: "{\n                  arrow: true,\n                  placement : 'bottom',\n                  zIndex: 1231231231233,\n                  boundary: 'window'\n                }"
      }],
      staticClass: "d-select__selected__item__warning icon__bg-circle icon__bg-circle--small",
      attrs: {
        "content": user.v_sub
      }
    }, [_c('span', {
      staticClass: "icon-users3"
    })]) : _vm._e(), _vm._v("\n                  " + _vm._s(user.name) + "\n                ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.eventSubstitutes.length > 0 && _vm.event.event_type !== 'absence') ? _c('div', {
    staticClass: "input-group input-group--uneditable"
  }, [_c('label', [_c('span', {
    staticClass: "icon-users3"
  }), _vm._v(" " + _vm._s(_vm.$t('vue2.edit_event.substitutes')))]), _vm._v(" "), _c('div', {
    staticClass: "event-cals"
  }, _vm._l((_vm.eventSubstitutes), function(cal) {
    return _c('div', {
      key: cal.calendar_id,
      staticClass: "event-cals__cal"
    }, [_vm._v("\n                  " + _vm._s(cal.name) + "\n                ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.eventRooms.length > 0 && _vm.event.event_type !== 'absence') ? _c('div', {
    staticClass: "input-group input-group--uneditable"
  }, [_c('label', [_c('span', {
    staticClass: "icon-location"
  }), _vm._v(" " + _vm._s(_vm.$t('vue2.edit_event.rooms')))]), _vm._v(" "), _c('div', {
    staticClass: "event-cals"
  }, _vm._l((_vm.eventRooms), function(cal) {
    return _c('div', {
      key: cal.calendar_id,
      staticClass: "event-cals__cal"
    }, [_vm._v("\n                  " + _vm._s(cal.name) + "\n                ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.eventKlasses.length > 0 && _vm.event.event_type !== 'absence') ? _c('div', {
    staticClass: "input-group input-group--uneditable"
  }, [_c('label', [_c('span', {
    staticClass: "icon-calendar4"
  }), _vm._v(" " + _vm._s(_vm.$t('vue2.edit_event.klass')))]), _vm._v(" "), _c('div', {
    staticClass: "event-cals"
  }, _vm._l((_vm.eventKlasses), function(cal) {
    return _c('div', {
      key: cal.calendar_id,
      staticClass: "event-cals__cal"
    }, [_vm._v("\n                  " + _vm._s(cal.name) + "\n                ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.eventStudents.length > 0 && _vm.event.event_type !== 'absence') ? _c('div', {
    staticClass: "input-group input-group--uneditable"
  }, [_c('label', [_c('span', {
    staticClass: "icon-calendar4"
  }), _vm._v(" " + _vm._s(_vm.$t('vue2.students.students')))]), _vm._v(" "), _c('div', {
    staticClass: "event-cals"
  }, _vm._l((_vm.eventStudents), function(cal) {
    return _c('div', {
      key: cal.calendar_id,
      staticClass: "event-cals__cal"
    }, [_vm._v("\n                  " + _vm._s(cal.name) + "\n                ")])
  }), 0)]) : _vm._e()] : [(_vm.usersNotOnSchool.length > 0) ? _c('DCalendarShowEventUsersNotOnSchool', {
    attrs: {
      "usersNotOnSchool": _vm.usersNotOnSchool,
      "event": _vm.event,
      "activeSchoolName": _vm.activeSchoolName
    },
    on: {
      "updateAndClose": _vm.updateAndClose
    }
  }) : _vm._e(), _vm._v(" "), (_vm.event.event_type !== 'absence') ? _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_c('span', {
    staticClass: "icon-user"
  }), _vm._v(" " + _vm._s(_vm.$t('vue2.edit_event.teachers')))]), _vm._v(" "), _c('DSelectCalendars', {
    attrs: {
      "itemType": "user",
      "showTags": true,
      "event": _vm.event,
      "eventId": _vm.event.event_id,
      "preSelectedItems": _vm.userCalendarIds,
      "itemsThatCantBeDeleted": _vm.usersWithSubstitute,
      "itemsUnselectable": _vm.substituteCalendarIds,
      "showCreateButton": false,
      "isEventSchoolIdTheSameAsActiveSchoolId": _vm.isEventSchoolIdTheSameAsActiveSchoolId,
      "eventSchoolCalendars": _vm.eventSchoolCalendars,
      "eventSchoolUsers": _vm.eventSchoolUsers,
      "eventSchoolYears": _vm.eventSchoolYears,
      "isDeleteAllAnOption": _vm.substituteCalendarIds.length === 0
    },
    on: {
      "updateAndClose": _vm.updateAndClose,
      "update": _vm.setSelectedUsers
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.event.event_type !== 'reservation' && _vm.event.event_type !== 'absence' && (_vm.userCalendarIds.length > 0 || this.ownerCalendarType === 'user')) ? _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_c('span', {
    staticClass: "icon-users3"
  }), _vm._v(" " + _vm._s(_vm.$t('vue2.edit_event.substitutes')))]), _vm._v(" "), _c('DSelectCalendars', {
    attrs: {
      "itemType": "user",
      "showTags": true,
      "event": _vm.event,
      "eventId": _vm.event.event_id,
      "preSelectedItems": _vm.substituteCalendarIds,
      "itemsUnselectable": _vm.userCalendarIds,
      "includeEventCalendar": true,
      "showCreateButton": false,
      "disableAddMore": _vm.possibleTeachersToSub.length < 1,
      "disableAddMoreMessage": _vm.i18n[_vm.locale]['only_one_substitute_per_teacher'],
      "isEventSchoolIdTheSameAsActiveSchoolId": _vm.isEventSchoolIdTheSameAsActiveSchoolId,
      "eventSchoolCalendars": _vm.eventSchoolCalendars,
      "eventSchoolUsers": _vm.eventSchoolUsers,
      "eventSchoolYears": _vm.eventSchoolYears
    },
    on: {
      "updateAndClose": _vm.updateAndClose,
      "update": _vm.setSelectedSubstitutes
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.event.event_type !== 'absence') ? _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_c('span', {
    staticClass: "icon-location"
  }), _vm._v(" " + _vm._s(_vm.$t('vue2.edit_event.rooms')))]), _vm._v(" "), _c('DSelectCalendars', {
    attrs: {
      "itemType": "room",
      "event": _vm.event,
      "eventId": _vm.event.event_id,
      "preSelectedItems": _vm.roomCalendarIds,
      "showCreateButton": false,
      "isEventSchoolIdTheSameAsActiveSchoolId": _vm.isEventSchoolIdTheSameAsActiveSchoolId,
      "eventSchoolCalendars": _vm.eventSchoolCalendars,
      "eventSchoolUsers": _vm.eventSchoolUsers,
      "eventSchoolYears": _vm.eventSchoolYears
    },
    on: {
      "updateAndClose": _vm.updateAndClose,
      "update": _vm.setSelectedRooms
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeEventTypeToSelect === 'kindergarten') ? [_c('div', {
    staticClass: "input-group"
  }, [_c('label', [_c('span', {
    staticClass: "icon-clipboard2"
  }), _vm._v(" Stuer")]), _vm._v(" "), _c('DSelectCalendars', {
    attrs: {
      "itemType": "kindergarten",
      "event": _vm.event,
      "eventId": _vm.event.event_id,
      "preSelectedItems": _vm.kindergartenCalendarsIds,
      "showCreateButton": false,
      "isEventSchoolIdTheSameAsActiveSchoolId": _vm.isEventSchoolIdTheSameAsActiveSchoolId,
      "eventSchoolCalendars": _vm.eventSchoolCalendars,
      "eventSchoolUsers": _vm.eventSchoolUsers,
      "eventSchoolYears": _vm.eventSchoolYears
    },
    on: {
      "updateAndClose": _vm.updateAndClose,
      "update": _vm.setSelectedKindergartenCalendar
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.activeEventTypeToSelect === 'club') ? [_c('div', {
    staticClass: "input-group"
  }, [_c('label', [_c('span', {
    staticClass: "icon-clipboard2"
  }), _vm._v(" " + _vm._s(_vm.$t('vue2.club.club')))]), _vm._v(" "), _c('DSelectCalendars', {
    attrs: {
      "itemType": "club",
      "event": _vm.event,
      "eventId": _vm.event.event_id,
      "preSelectedItems": _vm.clubCalendarsIds,
      "showCreateButton": false,
      "isEventSchoolIdTheSameAsActiveSchoolId": _vm.isEventSchoolIdTheSameAsActiveSchoolId,
      "eventSchoolCalendars": _vm.eventSchoolCalendars,
      "eventSchoolUsers": _vm.eventSchoolUsers,
      "eventSchoolYears": _vm.eventSchoolYears
    },
    on: {
      "updateAndClose": _vm.updateAndClose,
      "update": _vm.setSelectedClubCalendar
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.activeEventTypeToSelect === 'other') ? [_c('div', {
    staticClass: "input-group"
  }, [_c('label', [_c('span', {
    staticClass: "icon-clipboard2"
  }), _vm._v(" " + _vm._s(_vm.$t('vue2.common.other_calendars')))]), _vm._v(" "), _c('DSelectCalendars', {
    attrs: {
      "itemType": "other",
      "event": _vm.event,
      "eventId": _vm.event.event_id,
      "preSelectedItems": _vm.otherCalendarsIds,
      "showCreateButton": false,
      "isEventSchoolIdTheSameAsActiveSchoolId": _vm.isEventSchoolIdTheSameAsActiveSchoolId,
      "eventSchoolCalendars": _vm.eventSchoolCalendars,
      "eventSchoolUsers": _vm.eventSchoolUsers,
      "eventSchoolYears": _vm.eventSchoolYears
    },
    on: {
      "updateAndClose": _vm.updateAndClose,
      "update": _vm.setSelectedOtherCalendar
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.activeEventTypeToSelect === 'klass') ? [(_vm.event.event_type !== 'reservation' && _vm.event.event_type !== 'absence' && !_vm.isShowKlass) ? _c('div', {
    staticClass: "input-group input-group__label-link"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isShowKlass),
      expression: "isShowKlass"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isShowKlass) ? _vm._i(_vm.isShowKlass, null) > -1 : (_vm.isShowKlass)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isShowKlass,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isShowKlass = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isShowKlass = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isShowKlass = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "d-link-text",
    on: {
      "click": function($event) {
        return _vm.setIsShowKlass(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].add_grade))])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeInLeft"
    },
    on: {
      "after-enter": _vm.onKlassDSelectTransitionDone
    }
  }, [(_vm.event.event_type !== 'absence' && _vm.isShowKlass) ? _c('div', {
    staticClass: "input-group input-group__grades"
  }, [_c('label', [_c('span', {
    staticClass: "icon-calendar4"
  }), _vm._v(" " + _vm._s(_vm.$t('vue2.edit_event.klass')))]), _vm._v(" "), _c('DSelectCalendars', {
    attrs: {
      "itemType": "klass",
      "event": _vm.event,
      "eventId": _vm.event.event_id,
      "preSelectedItems": _vm.klassCalendarIds,
      "showCreateButton": false,
      "isEventSchoolIdTheSameAsActiveSchoolId": _vm.isEventSchoolIdTheSameAsActiveSchoolId,
      "eventSchoolCalendars": _vm.eventSchoolCalendars,
      "eventSchoolUsers": _vm.eventSchoolUsers,
      "eventSchoolYears": _vm.eventSchoolYears
    },
    on: {
      "updateAndClose": _vm.updateAndClose,
      "update": _vm.setSelectedKlasses
    }
  })], 1) : _vm._e()])] : _vm._e(), _vm._v(" "), (_vm.isStudentsActivated && _vm.event.event_type !== 'absence' && _vm.event.event_type !== 'reservation') ? _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_c('span', {
    staticClass: "icon-location"
  }), _vm._v(" " + _vm._s(_vm.$t('vue2.students.students')))]), _vm._v(" "), _c('DSelectCalendars', {
    attrs: {
      "itemType": "student",
      "event": _vm.event,
      "eventId": _vm.event.event_id,
      "preSelectedItems": _vm.studentCalendarIds,
      "showCreateButton": false,
      "isEventSchoolIdTheSameAsActiveSchoolId": _vm.isEventSchoolIdTheSameAsActiveSchoolId,
      "eventSchoolCalendars": _vm.eventSchoolCalendars,
      "eventSchoolUsers": _vm.eventSchoolUsers,
      "eventSchoolYears": _vm.eventSchoolYears
    },
    on: {
      "updateAndClose": _vm.updateAndClose,
      "update": _vm.setSelectedStudents
    }
  })], 1) : _vm._e()], _vm._v(" "), (_vm.isShowLearningGoal && (_vm.event.learning_goal.length > 0 || _vm.event.event_type !== 'absence') && (_vm.canEditNotes || (!_vm.canEditNotes && _vm.event.learning_goal.length > 0))) ? _c('div', {
    staticClass: "d-notes"
  }, [_c('label', {
    style: ({
      'color': _vm.event.color
    })
  }, [(!_vm.isCalendarOfTypeOther) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].learning_goal))]) : _vm._e(), _vm._v(" "), (_vm.isCalendarOfTypeOther) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].meeting_purpose))]) : _vm._e()]), _vm._v(" "), (!_vm.canEditNotes) ? _c('div', {
    staticClass: "dialog-text__content",
    domProps: {
      "innerHTML": _vm._s(_vm.event.learning_goal)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEditNotes) ? _c('weip', {
    attrs: {
      "isInDCalendar": true,
      "isInTestOfSaveButton": false,
      "lesson": _vm.event,
      "noteType": "learning_goal"
    },
    on: {
      "changed": function($event) {
        return _vm.setNoteChanges($event, 'learning_goal')
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isShowOnlyNotes && (_vm.event.description.length > 0 || _vm.event.event_type !== 'absence') && (_vm.canEditNotes || (!_vm.canEditNotes && _vm.event.description.length > 0))) ? _c('div', {
    staticClass: "d-notes"
  }, [_c('label', {
    style: ({
      'color': _vm.event.color
    })
  }, [(!_vm.isCalendarOfTypeOther) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].content))]) : _vm._e(), _vm._v(" "), (_vm.isCalendarOfTypeOther) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].agenda))]) : _vm._e()]), _vm._v(" "), (_vm.canEditNotes) ? _c('weip', {
    attrs: {
      "isInDCalendar": true,
      "isInTestOfSaveButton": false,
      "lesson": _vm.event,
      "noteType": "description"
    },
    on: {
      "changed": function($event) {
        return _vm.setNoteChanges($event, 'description')
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.canEditNotes) ? _c('div', {
    staticClass: "dialog-text__content",
    domProps: {
      "innerHTML": _vm._s(_vm.event.description)
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isShowNotesForStudent && (_vm.event.notes_for_students.length > 0 || _vm.event.event_type !== 'absence') && _vm.canEditNotes || (!_vm.canEditNotes && _vm.event.notes_for_students.length > 0)) ? _c('div', {
    staticClass: "d-notes"
  }, [_c('label', {
    style: ({
      'color': _vm.event.color
    })
  }, [(!_vm.isCalendarOfTypeOther) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].pupil_preparation))]) : _vm._e(), _vm._v(" "), (_vm.isCalendarOfTypeOther) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].decisions_and_resume))]) : _vm._e()]), _vm._v(" "), (_vm.canEditNotes) ? _c('weip', {
    attrs: {
      "isInDCalendar": true,
      "isInTestOfSaveButton": false,
      "lesson": _vm.event,
      "noteType": "notes_for_students"
    },
    on: {
      "changed": function($event) {
        return _vm.setNoteChanges($event, 'notes_for_students')
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.canEditNotes) ? _c('div', {
    staticClass: "dialog-text__content",
    domProps: {
      "innerHTML": _vm._s(_vm.event.notes_for_students)
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isShowTeacherNotes && _vm.canEditNotes || (!_vm.canEditNotes && _vm.event.teacher_notes.length > 0)) ? _c('div', {
    staticClass: "d-notes"
  }, [_c('label', {
    style: ({
      'color': _vm.event.color
    })
  }, [(!_vm.isCalendarOfTypeOther) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].teacher_notes))]) : _vm._e(), _vm._v(" "), (_vm.isCalendarOfTypeOther) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].internal_notes))]) : _vm._e()]), _vm._v(" "), (_vm.canEditNotes) ? _c('weip', {
    attrs: {
      "isInDCalendar": true,
      "isInTestOfSaveButton": false,
      "lesson": _vm.event,
      "noteType": "teacher_notes"
    },
    on: {
      "changed": function($event) {
        return _vm.setNoteChanges($event, 'teacher_notes')
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.canEditNotes) ? _c('div', {
    staticClass: "dialog-text__content",
    domProps: {
      "innerHTML": _vm._s(_vm.event.teacher_notes)
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.event.event_type !== 'frame') ? _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_c('span', {
    staticClass: "icon-clock"
  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['this_lesson_counts_as']))]), _vm._v(" "), _c('p', {
    staticClass: "lesson-count-as"
  }, [_vm._v(_vm._s(_vm.eventTypeTranslated) + ": " + _vm._s(_vm.eventDurationForCalendar))])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.isTheActiveTab(1)) ? _c('div', {
    staticClass: "d-show-event__form"
  }, [_c('EventChanges', {
    attrs: {
      "event": _vm.event,
      "event-id": _vm.event.event_id
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isTheActiveTab(2)) ? _c('div', {
    staticClass: "d-show-event__form"
  }, [_c('EventSwapOrReplace', {
    attrs: {
      "propEvent": _vm.event,
      "type": "swap"
    },
    on: {
      "update": _vm.updateAndClose
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isTheActiveTab(3)) ? _c('div', {
    staticClass: "d-show-event__form"
  }, [_c('EventSwapOrReplace', {
    attrs: {
      "propEvent": _vm.event,
      "type": "replace"
    },
    on: {
      "update": _vm.updateAndClose
    }
  })], 1) : _vm._e()]], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeUp"
    }
  }, [(_vm.isChangesMade) ? _c('div', {
    staticClass: "d-show-event__footer"
  }, [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        placement: 'top',
        zIndex: 12312312312312
      }),
      expression: "{\n                  placement : 'top',\n                  zIndex: 12312312312312\n                }"
    }],
    staticClass: "bttn-primary bttn box-shadow",
    attrs: {
      "disabled": _vm.isUpdating,
      "content": _vm.saveKeyTooltip
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "bttn box-shadow marg-1-left",
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.dont_save')))])]) : _vm._e()]), _vm._v(" "), (_vm.isConfirmDelete && !_vm.isAway) ? _c('ModalConfirmation', {
    staticClass: "d-modal--from-top",
    attrs: {
      "show-close": false,
      "appendToBody": true,
      "isOnlyOwnCalendarText": _vm.isOnlyOwnCalendarTextWarning
    },
    on: {
      "close": _vm.closeIsConfirmDelete,
      "confirm": _vm.deleteEvent
    }
  }, [(_vm.originalSubstituteCalendarIds.length > 0) ? _c('div', {
    staticClass: "d-custom-warning alert",
    attrs: {
      "slot": "custom_warning"
    },
    slot: "custom_warning"
  }, [_c('span', {
    staticClass: "icon-users3"
  }), _vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['you_are_about_to_delete_substitutes']) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isConfirmDelete && _vm.isAway) ? _c('DModalDeleteAwayEvent', {
    attrs: {
      "event": _vm.event,
      "appendToBody": true
    },
    on: {
      "deleted": _vm.onAwayEventDeleted,
      "close": _vm.closeIsConfirmDelete
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isConfirmRemoveOwnerAsSubstitute) ? _c('ModalConfirmation', {
    staticClass: "d-modal--from-top",
    attrs: {
      "show-close": false,
      "appendToBody": true,
      "isShowConfirmDeleteMessage": false
    },
    on: {
      "close": function($event) {
        _vm.isConfirmRemoveOwnerAsSubstitute = false
      },
      "confirm": _vm.confirmRemoveOwnerAsSubstitute
    }
  }, [_c('div', {
    staticClass: "d-custom-warning alert",
    attrs: {
      "slot": "custom_warning"
    },
    slot: "custom_warning"
  }, [_c('span', {
    staticClass: "icon-users3"
  }), _vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['remove_owner_as_substitute']) + "\n      ")]), _vm._v(" "), _c('template', {
    slot: "confirmText"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['ok']))])], 2) : _vm._e(), _vm._v(" "), (_vm.subToSelectWhoToSubFor) ? _c('DCalendarsShowEventSubFor', {
    attrs: {
      "substitute": _vm.subToSelectWhoToSubFor,
      "teachers": _vm.possibleTeachersToSub
    },
    on: {
      "select": _vm.setTeacherToSub,
      "cancel": _vm.cancelSubToSelectWhoToSubFor
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.isClosingWithoutSaving && !_vm.isEventLoading) ? _c('DModal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true
    }
  }, [_c('div', {
    staticClass: "d-modal d-modal__closing-without-saving text-dark",
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.common.save_changes')))])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('p', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['unsaved_changes_will_be_lost']))])]), _vm._v(" "), _c('div', {
    staticClass: "doc-modal__footer"
  }, [_c('button', {
    staticClass: "bttn bttn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.save')) + "\n        ")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.dont_save')))]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isClosingWithoutSaving = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))])])])]) : _vm._e(), _vm._v(" "), (_vm.isCancelLesson) ? _c('DModalCancelLesson', {
    attrs: {
      "event": _vm.event
    },
    on: {
      "updated": _vm.onEventUpdated,
      "close": function($event) {
        return _vm.setIsCancelLesson(false)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOutOfSchoolLesson) ? _c('DModalOutOfSchoolLesson', {
    attrs: {
      "event": _vm.event
    },
    on: {
      "updated": _vm.onEventUpdated,
      "close": function($event) {
        return _vm.setIsOutOfSchoolLesson(false)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isChangesMade) ? _c('div', {
    staticClass: "d-show-event__overlay",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeClick.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dialog-icon"
  }, [_c('span', {
    staticClass: "icon-clock"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78a1e642!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DCalendar/DCalendarShowEvent.vue
// module id = 2022
// module chunks = 1